import SelectBox from "legacy/elements/explore/select-box";
import {
  ExploreFilterItem,
  ExploreFilterSchemaFields,
} from "@modules/new-explore/types";

interface Props<T> {
  item: ExploreFilterItem<T>[];
  filterName: ExploreFilterSchemaFields;
  checkAllSelected?: boolean;
}

// eslint-disable-next-line no-unused-vars
function ExploreSelectBox<T>({
  item,
  filterName,
  checkAllSelected = true,
}: Props<string>) {
  return (
    <div>
      <SelectBox
        filterName={filterName}
        items={item}
        checkAllSelected={checkAllSelected}
      />
    </div>
  );
}

export default ExploreSelectBox;
